// Fonctions de formatage pour nombres et montants

/**
 * Formate un montant avec séparateur de millier (.) et décimal (,)
 * Ex: 1234.56 devient "1.234,56 FCFA"
 */
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '0,00 FCFA';
  
  const parts = parseFloat(amount).toFixed(2).split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const decimalPart = parts[1];
  
  return `${integerPart},${decimalPart} FCFA`;
};

/**
 * Formate un nombre avec séparateur de millier (.) et décimal (,)
 * Ex: 1234.56 devient "1.234,56"
 */
export const formatNumber = (num) => {
  if (num === null || num === undefined) return '0,00';
  
  const parts = parseFloat(num).toFixed(2).split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const decimalPart = parts[1];
  
  return `${integerPart},${decimalPart}`;
};

/**
 * Formate une consommation (m³) avec séparateur décimal (,)
 * Ex: 1234.56 devient "1.234,56 m³"
 */
export const formatConsumption = (consumption) => {
  if (consumption === null || consumption === undefined) return '0,00 m³';
  
  const parts = parseFloat(consumption).toFixed(2).split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const decimalPart = parts[1];
  
  return `${integerPart},${decimalPart}`;
};

/**
 * Formate un montant sans devise pour les exports/rapports
 */
export const formatAmount = (amount) => {
  if (amount === null || amount === undefined) return '0,00';
  
  const parts = parseFloat(amount).toFixed(2).split('.');
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const decimalPart = parts[1];
  
  return `${integerPart},${decimalPart}`;
};
